import { useEffect, useState } from 'react';
import { i18n, serviceClient } from '@yola/ws-sdk';

const useCategoryLoadingBySlug = (categorySlug, onLoad) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const getCategoryBySlug = async (slug) => {
      try {
        const client = serviceClient.get();
        const locale = i18n.accessors.getLocale();
        const { data } = await client.taxonomyGetCategory({ slug, locale });

        onLoad(data);
      } catch (error) {
        console.error(error);
      }

      setIsLoaded(true);
    };

    if (categorySlug) {
      getCategoryBySlug(categorySlug);
    } else {
      setIsLoaded(true);
    }

    return () => {
      setIsLoaded(false);
    };
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  return isLoaded;
};

export default useCategoryLoadingBySlug;
